import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css'
import logo from '../../Assets/g.png';
import LanguageSelector from '../LanguageSelector/LanguageSelector';

const Navbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { t } = useTranslation();

  const links = [
    { path: '/Home', text: t('common:menu.home') },
    { path: '/About', text: t('common:menu.about') },
    { path: '/News', text: t('common:menu.news') },
    { path: '/Partnership', text: t('common:menu.partnership') },
    { path: '/ProjectResults', text: t('common:menu.projectResults') }
  ];

  return (
    <div className='nav-container'>
      <div className='nav'>
        <div className='nav-logo'>
          <img src={logo} alt='Green Transitions Logo' />
        </div>
        <div className='nav-right'>
          <ul className='nav-menu'>
            {links.map((link) => (
              link.path !== currentPath && (
                <li key={link.path}>
                  <Link to={link.path} style={{ textDecoration: 'none' }}>
                    {link.text}
                  </Link>
                </li>
              )
            ))}
          </ul>
        </div>
      </div>
      <div className='language-selector-container'>
        <LanguageSelector />
      </div>
    </div>
  );
};

export default Navbar;